import { CookieHelper } from '@/shared/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CookieBarComponent extends Vue {

    @Prop() public translations!: { [key: string]: string; };

    public get hasAccepted(): boolean {

        const cookie = this.cookie.get(this.cookieName);

        return cookie === this.cookieAcceptValue;
    }

    public show: boolean = false;

    private cookieName: string = 'easyvote_cookies_accepted';

    private cookieAcceptValue: string = 'true';

    private cookie: CookieHelper = new CookieHelper();

    public created(): void {

        // tslint:disable-next-line:no-string-literal
        this.show = !this.hasAccepted;
    }

    public accept($event: MouseEvent) {

        this.cookie.create(this.cookieName, this.cookieAcceptValue, 730, 'Lax');

        this.show = false;
    }
}
